<div class="modal-header">
  <h4 class="modal-title" translate>{{ !isCreate ? 'PARTNER_AGREEMENT_EDIT' : 'PARTNER_AGREEMENT_CREATE' }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" [formGroup]="partnerAgreementForm">
  <div class="row">
    <div *ngIf="customerOptionsList" class="col-12 col-sm-6 mb-2 mb-sm-0">
      <lib-gung-input-multi-select
        label="CUSTOMER"
        [optionsList]="customerOptionsList"
        (selectedValues)="setSelectedCustomerId($event)"
        [singleSelection]="true"
        [previewField]="['id', ' - ', 'name']"
      ></lib-gung-input-multi-select>
      <lib-forms-message-error [controller]="partnerAgreementForm.get('customerId')"></lib-forms-message-error>
    </div>

    <div *ngIf="partnerOptionsList" class="col-12 col-sm-6">
      <lib-gung-input-multi-select
        label="PARTNER"
        [optionsList]="partnerOptionsList"
        (selectedValues)="setSelectedPartnerId($event)"
        [singleSelection]="true"
        [previewField]="['id', ' - ', 'name']"
      ></lib-gung-input-multi-select>
      <lib-forms-message-error [controller]="partnerAgreementForm.get('partnerId')"></lib-forms-message-error>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-12 col-sm-6 mb-3 mb-sm-0">
      <lib-gung-text-input
        gungTranslate="SUPPLIER_ID"
        formControlName="supplierId"
        [placeholder]="'SUPPLIER_ID' | translate"
      ></lib-gung-text-input>
      <lib-forms-message-error [controller]="partnerAgreementForm.get('supplierId')"></lib-forms-message-error>
    </div>

    <div class="col-12 col-sm-6">
      <lib-gung-text-input
        gungTranslate="SERVICE_PRICE_LIST_ID"
        formControlName="servicePriceListId"
        [placeholder]="'SERVICE_PRICE_LIST_ID' | translate"
      ></lib-gung-text-input>
      <lib-forms-message-error [controller]="partnerAgreementForm.get('servicePriceListId')"></lib-forms-message-error>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <lib-gung-input-file
        [multiple]="false"
        [enableDragDrop]="true"
        (onFileSelect)="selectFiles($event)"
      ></lib-gung-input-file>
      <lib-forms-message-error [controller]="partnerAgreementForm.get('agreementFiles')"></lib-forms-message-error>
      <a *ngIf="filePreviewUrl" class="btn btn-primary ml-2" [href]="filePreviewUrl" target="_blank" translate>PREVIEW_AGREEMENT</a>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()" translate>CANCEL</button>
  <button type="button" class="btn btn-primary" (click)="onSave($event)" translate>
    SAVE
  </button>
</div>
